export function computeTargetSize(reported: number | undefined, start: number): number {
  const value = Math.round(reported ?? 0);
  return Math.round(2 * value - start);
}

export function isResizeWithinBounds(
  width: number,
  height: number,
  minWidth: number,
  minHeight: number,
  viewportWidth: number,
  viewportHeight: number,
): boolean {
  if (width < minWidth || height < minHeight) {
    return false;
  }
  return width <= viewportWidth && height <= viewportHeight;
}
